var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationClinic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.0001 17.9377C11.4883 17.9377 9.4707 15.9201 9.4707 13.4083C9.4707 10.8966 11.4883 8.87891 14.0001 8.87891C16.5119 8.87891 18.5295 10.8966 18.5295 13.4083C18.5295 15.9201 16.5119 17.9377 14.0001 17.9377ZM14.0001 10.9377C12.6413 10.9377 11.5295 12.0495 11.5295 13.4083C11.5295 14.7671 12.6413 15.8789 14.0001 15.8789C15.3589 15.8789 16.4707 14.7671 16.4707 13.4083C16.4707 12.0495 15.3589 10.9377 14.0001 10.9377Z",
    fill: "#A461D8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.9985 26.6665C13.1338 26.6665 12.269 26.3371 11.6102 25.6783L6.66905 20.7371C2.63375 16.7018 2.63375 10.1136 6.66905 6.07831C8.64552 4.10184 11.2396 3.03125 13.9985 3.03125C16.7573 3.03125 19.3514 4.10184 21.3279 6.07831C25.3632 10.1136 25.3632 16.7018 21.3279 20.7371L16.3867 25.6783C15.7279 26.3371 14.8632 26.6665 13.9985 26.6665ZM13.9985 5.09007C11.8573 5.09007 9.75728 5.9136 8.11023 7.51948C4.85728 10.7724 4.85728 16.043 8.11023 19.2548L13.0514 24.196C13.5455 24.6901 14.369 24.6901 14.9043 24.196L19.8455 19.2548C23.0985 16.0018 23.0985 10.7312 19.8455 7.51948C18.2396 5.9136 16.1396 5.09007 13.9985 5.09007Z",
    fill: "#A461D8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationClinic);
export default __webpack_public_path__ + "static/media/location-clinic.e1844f7d4bcfbdef73d6efd0ecdb28d0.svg";
export { ForwardRef as ReactComponent };